// Copyright (c) 2023 WiseTime. All rights reserved.

import { Observable, of, throwError } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as Slice from "../slices/additionalUi"
import { AUTO_NARRATIVE } from "../../../app/localStorageKeys"

export type StorageReader = () => Observable<boolean>

export const load: StorageReader = () => {
  try {
    const data = localStorage.getItem(AUTO_NARRATIVE)
    if (data !== null) {
      return of(data === "true")
    }
    return of()
  } catch (error) {
    return throwError(error)
  }
}

export const loadAutoNarrative = (load: StorageReader) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.loadAutoNarrativeFromStorage.match),
      mergeMap(_ => load().pipe(
        map(autoNarrative => ({ autoNarrative })),
        map(Slice.setAutoNarrative),
        catchError(_ => of(Actions.loadAutoNarrativeFromStorageFailed())),
      )),
    )

export default loadAutoNarrative(load)

